import LicenseFeatureGroupComposer from "@/v2-backoffice-client/license/featureGroup/compose/LicenseFeatureGroupComposer"
import type { FeatureGroupFragment } from "@/v2-backoffice-client/license/featureGroup/__types__/license.featureGroup.fragment"

export type LicenseFeatureGroupFeaturesTabProps = {
  featureGroup: FeatureGroupFragment
}

// The package panel's Features tab: what this package grants, as three
// sections an operator reads top-down — content classes with a three-way
// grant each, the rare specific feature, and the app's capabilities as an
// area-by-area checklist — over a footer that writes the whole draft on
// Save or drops it on Reset. The section headers say in a sentence what
// the package grants right now.
function LicenseFeatureGroupFeaturesTab(
  props: LicenseFeatureGroupFeaturesTabProps,
) {
  const { featureGroup } = props
  return (
    <div className="h-full min-h-0">
      <LicenseFeatureGroupComposer featureGroup={featureGroup} />
    </div>
  )
}

export default LicenseFeatureGroupFeaturesTab
